export * from './exam-location-page.component';
